module.exports = __webpack_public_path__ + "img/chat.2101a480.svg";